import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate';
import { useAdminContext } from '../../../context/adminContext';
import { changePartnerEarningWithdrawRequestStatusApi, cityByCountryApi, countryListApi, downloadWeeklyWithdrawalsApi, getAllRewardWithdrawRequestsApi, getWeeklyWidhdrawalRequestsApi, getWeeklyWithdrawalsDatesApi, partnerEarningWithdrawRequestApi, partnerEarningWithdrawRequestListDownload } from '../../../utils/ApiEndpointFunctions';
import { capitalizeWords, dateFormat } from '../../../utils/HelperFuncitons';
import LimitPagination from '../../common/LimitPagination';
import CommonTable from '../../common/Table/CommonTable'
import ConfirmationModal from '../../common/ConfirmationModal';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import ReactSelect from 'react-select';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import WeeklyMarkPaidModal from '../../common/Modal/WeeklyMarkPaidModal';
import { S3_URL } from '../../../utils/BaseUrl';



const WithdrawalRequest = () => {
  const [loader, setLoader] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalCount, setTotalCount] = useState(null);
  const [page, setPage] = useState(0);
  const [confirmStatus, setConfirmStatus] = useState({ status: "", id: 0 })
  const { limit, adminDetail } = useAdminContext();
  const [activeTab, setActiveTab] = useState('instant');
  const [weeklyDates, setWeeklyDates] = useState([]);
  const [isWeeklyDetail, setIsWeeklyDetail] = useState(false);
  const [selectedWeek, setSelectedWeek] = useState({ from: null, to: null });
  const [weeklyPage, setWeeklyPage] = useState(1);
  const [weeklyTotalCount, setWeeklyTotalCount] = useState(0);
  const [weeklyPageCount, setWeeklyPageCount] = useState(0);
  const [tableLoader, setTableLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [weeklyDownloadLoader, setWeeklyDownloadLoader] = useState(false);
  const [selectedInstantItem, setSelectedInstantItem] = useState(null);
  const [selectedWeeklyItem, setSelectedWeeklyItem] = useState(null);
  const [selectedRewardItem, setSelectedRewardItem] = useState(null);
  const [rewardPage, setRewardPage] = useState(1);
  const [rewardTotalCount, setRewardTotalCount] = useState(0);
  const [rewardPageCount, setRewardPageCount] = useState(0);


  const [countryOptions, setCountryOptions] = useState([])
  const [cityOptions, setCityOptions] = useState([])
  
    const filterCites = async (countryId) => {
      try {
        const res = await cityByCountryApi("", countryId)
        if (res.status === 200) {
          let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
          setCityOptions(cityOption);
        }
  
      } catch (error) {
        console.log(error)
      }
    };
  
    const filterCountry = async (inputValue) => {
      try {
        const res = await countryListApi(inputValue)
        if (res.status === 200) {
          let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
          setCountryOptions(cityOption);
        }
      } catch (error) {
        console.log(error)
      }
    };
  
    const handleCityChange = (city) => {
      searchFormik.setFieldValue('cityId', city)
    }
  
    const handleCountryChange = (country) => {
      console.log(country, 'this is count')
      setCityOptions([])
      searchFormik.setFieldValue('countryId', country);
      searchFormik.setFieldValue('cityId', null);
      filterCites(country.value)
    }
  
    const searchFormik = useFormik({
      initialValues: {
        countryId: adminDetail.role !== "superAdmin" && adminDetail.countryId ? { label: adminDetail.countryName, value: adminDetail.countryId } : null, 
        cityId: null,
      },
    })

  const confirmApproveOrReject = (status, id) => {
    setConfirmStatus({ status, id })
    document.getElementById('confirmModalBtn').click()
  }

 const onSuccessRes = () => {
  if (activeTab === "weekly") {
    getWeeklyDetails(
      selectedWeek.from,
      selectedWeek.to,
      weeklyPage,
      limit
    );
  }  else if (activeTab === "reward") {
    getRewardRequests(rewardPage, limit);
  } else {
    getAllRequest(selectedPage, limit); 
  }
};

  const getAllRequest = async (selectedPage, limit) => {
    try {
       setTableLoader(true);
      console.log(searchFormik.values?.countryId?.label, searchFormik.values?.cityId?.label)
      const res = await partnerEarningWithdrawRequestApi("", limit, selectedPage, searchFormik.values?.countryId?.label, searchFormik.values?.cityId?.label)
      if (res.status === 200 || res.status === 201) {
        const usersData = res?.data?.data?.withdrawList;
        const totalLength = res?.data?.data?.totalLength;
        setTotalCount(totalLength);
        setPage(Math.ceil(totalLength / limit));
        setTableData(usersData);
        setTableLoader(false);
      }
    } catch (error) {
      console.log(error)
    }
     setTableLoader(false);
  }

  const getWeeklyDates = async () => {
  try {
     setTableLoader(true);
    const res = await getWeeklyWithdrawalsDatesApi();

    if (res.status === 200) {
      setWeeklyDates(res.data?.data || []);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setTableLoader(false);
  }
};


  const handlePageClick = (event) => {
    let currentPage = event.selected + 1;
    getAllRequest(currentPage, limit)
    setSelectedPage(currentPage)
  };

  const getWalletAmount = (item) => {
    const role = item?.role?.[0]
    return role === "driver" ? (item?.driverDetails?.length ? item.driverDetails[0].walletAmount : 0)
      : role === "hire" ? item?.rentalVendor?.walletAmount
        : role === "restaurant" ? item?.restaurant?.walletAmount
          : role === "salesAgent" ? item?.salesAgent?.walletAmount
            : role === "busOperator" ? item?.busOperator?.walletAmount
            : 0
  }

  const headerData = [
    { name: "S.NO", className: "col-1", key: "sNo" },
    { name: "Name", className: "col-1", key: "name" },
    { name: "Phone", className: "col-1", key: "phone" },
    { name: "Role", className: "col-1", key: "role" },
    { name: "Date", className: "col-1", key: "date" },
    { name: "Requested Amount", className: "col-1", key: "amount" },
    { name: "Payable Amount", className: "col-1", key: "payAmount" },
    { name: "Widhrawal charge (%)", className: "col-1", key: "withdrawalCharge" },
    activeTab === "instant" && { name: "Wallet Amount", className: "col-1", key: "walletAmount" },
    { name: "Transaction ID", key: "transactionId" },
    { name: "Payment Mode", key: "paymentMode" },
    { name: "Attachment", key: "attachment" },
    { name: "Status", className: "col-1", key: "status" },
    { name: "Action", className: "col-1", key: "action" },
  ]
const handleDownload = async () => {
  try {
    setDownloadLoader(true);
    const response = await partnerEarningWithdrawRequestListDownload(
      searchFormik.values?.countryId?.label,
      searchFormik.values?.cityId?.label
    );
      setDownloadLoader(false);
    const jsonData = response.data?.data || [];

    if (!jsonData.length) {
      toast.error("No data found to export");
      setDownloadLoader(false);
      return;
    }

    // Flatten the nested objects into a sheet-friendly array of plain objects
    const flattened = jsonData.map((item, idx) => {
      const partnerUser = item?.partnerUser || {};
      const partnerDetails = partnerUser?.partnerUserDetails?.[0] || {};
      const role = (item?.role && item.role === "salesAgent") ? "Sales Agent" : (item?.role || "");
      // derive wallet amount similar to getWalletAmount function
      const userRole = partnerUser?.role?.[0];
      const walletAmount = userRole === "driver" ? (partnerUser?.driverDetails?.[0]?.walletAmount ?? 0)
        : userRole === "hire" ? (partnerUser?.rentalVendor?.walletAmount ?? 0)
        : userRole === "restaurant" ? (partnerUser?.restaurant?.walletAmount ?? 0)
        : userRole === "salesAgent" ? (partnerUser?.salesAgent?.walletAmount ?? 0)
        : userRole === "busOperator" ? (partnerUser?.busOperator?.walletAmount ?? 0)
        : 0;

      return {
        'S.NO': idx + 1,
        'Name': partnerDetails?.name ? capitalizeWords(partnerDetails.name) : "-",
        'Phone': partnerUser?.phone || "-",
        'Role': role ? capitalizeWords(role) : (item?.role ? capitalizeWords(item.role) : "-"),
        'Date': dateFormat(item?.createdAt),
        'Requested Amount': item?.amount ?? 0,
        'Payable Amount': item?.payAmount ?? 0,
        'Withdrawal Charge (%)': item?.withdrawalCharge ?? 0,
        'Wallet Amount': walletAmount,
        'Status': item?.status === "approved" ? "Paid" : (item?.status || "-"),
      }
    });

    // JSON → Worksheet
    const worksheet = XLSX.utils.json_to_sheet(flattened, { skipHeader: false });

    // Workbook create
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Withdraw Requests");

    // Excel file generate
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "withdraw_requests.xlsx");
    toast.success("File downloaded successfully!");
    setDownloadLoader(false);
  } catch (error) {
    console.error(error);
    toast.error(error?.response?.data?.message || "Something went wrong");
    setDownloadLoader(false);
  }
};

  const RequestTableData = tableData?.map((item, index) => ({
    sNo: index + 1,
    name: item?.partnerUser?.partnerUserDetails?.[0]?.name ? capitalizeWords(item?.partnerUser?.partnerUserDetails?.[0]?.name) : "-",
    phone: item?.partnerUser?.phone ? capitalizeWords(item?.partnerUser?.phone) : "-",
    role: item.role ? capitalizeWords(item.role === "salesAgent" ? "Sales Agent" : item.role) : "-",
    date: dateFormat(item.createdAt),
    amount: item?.amount ?? "0",
    payAmount: item?.payAmount ?? "0",
    withdrawalCharge: item?.withdrawalCharge ?? "0",
    walletAmount: getWalletAmount(item?.partnerUser),

     transactionId: item?.transactionId || "-",

  paymentMode: item?.mode
    ? capitalizeWords(item.mode)
    : "-",

  attachment: item?.attachment ? (
    <img
      src={`${S3_URL}/${item.attachment}`}
      alt="attachment"
      style={{
        width: "60px",
        height: "60px",
        objectFit: "cover",
        borderRadius: "6px",
        cursor: "pointer",
        border: "1px solid #ddd",
      }}
      onClick={() =>
        window.open(`${S3_URL}/${item.attachment}`, "_blank")
      }
    />
  ) : "-",

    status: item?.status === "approved" ? "Paid" : (item?.status || "-"),
    action: item?.status === "pending" ? (
      <div className="dropdown">
        <button
          className=" border-0 bg-white"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </button>
        <ul
          className="dropdown-menu"
          style={{ zIndex: "1000" }}
        >
          <li
            className="dropdown-item"
            onClick={() => {
              setSelectedInstantItem(item);      
              setTimeout(() => {
                document.getElementById("openWeeklyPaidModal").click();
              }, 0);
            }}
            style={{
              cursor:"pointer"
            }}
          >
            Mark as Paid
          </li>
          <li className="dropdown-item" onClick={() => confirmApproveOrReject('rejected', item?.id)}>
            <div style={{ cursor: "pointer" }}
            >
              Reject
            </div>
          </li>
        </ul>
      </div>
    ) : null
  }))

  const getWeeklyDetails = async (from, to, page = 1, limit = 10) => {
  try {
    setTableLoader(true);

    const res = await getWeeklyWidhdrawalRequestsApi(from, to, page, limit);

    if (res.status === 200 && res.data?.status === 1) {
      setTableData(res.data.data || []);
      setWeeklyTotalCount(res.data.totalCount || 0);
      setWeeklyPageCount(Math.ceil(res.data.totalCount / limit));
    } else {
      setTableData([]);
      setWeeklyTotalCount(0);
    }
  } catch (error) {
    toast.error("Failed to load weekly withdrawal details");
  } finally {
    setTableLoader(false);
  }
};


 const handleWeeklyDateClick = (item) => {
  setIsWeeklyDetail(true);
  setActiveTab("weekly");
  setSelectedWeek({ from: item.from, to: item.to });
  setWeeklyPage(1);

  getWeeklyDetails(item.from, item.to, 1, limit);
};

  const weeklyHeader = [
    { name: "S.NO", className: "col-2", key: "sNo" },
    { name: "From", className: "col-4", key: "from" },
    { name: "To", className: "col-4", key: "to" },
    { name: "Action", className: "col-2", key: "action" }
  ];


 const WeeklyTableData = weeklyDates.map((item, index) => ({
  sNo: index + 1,
  from: dateFormat(item.from),
  to: dateFormat(item.to),
  action: (
    <span
      style={{
        cursor: "pointer",
        color: "#0d6efd",
        fontWeight: 500
      }}
      onClick={() => handleWeeklyDateClick(item)}
    >
      View
    </span>
  )
}));

const weeklyDetailHeaders = [
  { name: "S.NO", key: "sNo" },
  { name: "Name", key: "name" },
  { name: "Phone", key: "phone" },
  { name: "Role", key: "role" },
  { name: "From", key: "from" },
  { name: "To", key: "to" },
  // { name: "Requested Amount", key: "amount" },
  { name: "Wallet Amount", key: "walletAmount" },
  { name: "Transaction ID", key: "transactionId" },
  { name: "Payment Mode", key: "paymentMode" },
  { name: "Attachment", key: "attachment" },
  { name: "Status", key: "status" },
   { name: "Action", key: "action" },
];

const WeeklyDetailTableData = tableData?.map((item, index) => {
  const partnerUser = item?.partnerUser || {};
  const details = partnerUser?.partnerUserDetails?.[0] || {};
  const role = partnerUser?.role?.[0] || "-";

  return {
    sNo: index + 1,
    name: details?.name ? capitalizeWords(details.name) : "-",
    phone: partnerUser?.phone || "-",
    role: role ? capitalizeWords(role) : "-",
    from: dateFormat(item.from),
    to: dateFormat(item.to),
    // amount: item.walletAmount ?? 0,
    walletAmount: item.walletAmount ?? 0,
    transactionId: item?.transactionId || "-",
    paymentMode: item?.mode ? capitalizeWords(item.mode) : "-",
    status: capitalizeWords(item.status || "-"),

     attachment: item?.attachment ? (
      <img
        src={`${S3_URL}/${item.attachment}`}
        alt="attachment"
        style={{
          width: "60px",
          height: "60px",
          objectFit: "cover",
          borderRadius: "6px",
          cursor: "pointer",
          border: "1px solid #ddd"
        }}
        onClick={() =>
          window.open(`${S3_URL}/${item.attachment}`, "_blank")
        }
      />
    ) : (
      "-"
    ),
  
     action:
      item?.status === "pending" ? (
        <div className="dropdown">
          <button
            className="border-0 bg-white"
            type="button"
            data-bs-toggle="dropdown"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-three-dots-vertical"
              viewBox="0 0 16 16"
            >
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            </svg>
          </button>

          <ul className="dropdown-menu cursor-pointer">
            <li
              className="dropdown-item"
              style={{cursor:"pointer"}}
              onClick={() => {
                setSelectedWeeklyItem(item);
              setTimeout(() => {
                document.getElementById("openWeeklyPaidModal").click();
              }, 0);
              }}
            >
              Mark As Paid
            </li>
          </ul>
        </div>
      ) : null,
  };
});

const handleWeeklyPageClick = (event) => {
  const currentPage = event.selected + 1;
  setWeeklyPage(currentPage);

  getWeeklyDetails(
    selectedWeek.from,
    selectedWeek.to,
    currentPage,
    limit
  );
};


  const handleChangeStatus = async () => {
    try {
      setLoader(true)
      await changePartnerEarningWithdrawRequestStatusApi(confirmStatus)
      getAllRequest(selectedPage, limit);
      document.getElementById('confirmationModal').click()
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
      setLoader(false)
    }
  }

  useEffect(() => {
    getAllRequest(selectedPage, limit);

  }, [searchFormik.values])

  useEffect(() => {
    if (adminDetail?.countryId) {
      filterCites(adminDetail.countryId);
    }
  
    if (adminDetail?.role === "superAdmin") {
      filterCountry();
    }
  }, [adminDetail]);

    const tabData = [
    { name: "Instant", tab: "instant" },
    { name: "Weekly", tab: "weekly" },
     { name: "Reward", tab: "reward" },
  ]

 const handleChangeTab = (tab) => {
  // if (loader) return;

  setSelectedPage(1);
  setRewardPage(1);
  setPage(0);
  setTotalCount(null);

  setWeeklyPage(1);
  setWeeklyTotalCount(0);
  setWeeklyPageCount(0);

  setTableData([]);
  setIsWeeklyDetail(false);
  setSelectedWeek({ from: null, to: null });

  setActiveTab(tab);

  if (tab === "weekly") {
    getWeeklyDates();
  }else if (tab === "reward") {
    getRewardRequests(1, limit); 
  }  
  else {
    getAllRequest(1, limit);
  }
};


const handleWeeklyDownload = async () => {
  try {
    setWeeklyDownloadLoader(true);

    const res = await downloadWeeklyWithdrawalsApi(
      selectedWeek.from,
      selectedWeek.to
    );

    const jsonData = res.data?.data || [];

    if (!jsonData.length) {
      toast.error("No data found to export");
      setWeeklyDownloadLoader(false);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(jsonData, {
      skipHeader: false,
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Weekly Withdrawals"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array", 
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      blob,
      `weekly_withdrawals_${dateFormat(selectedWeek.from)}_${dateFormat(selectedWeek.to)}.xlsx`
    );

    toast.success("Weekly withdrawals downloaded");
    setWeeklyDownloadLoader(false);

  } catch (error) {
    console.error(error);
    toast.error("Failed to download weekly withdrawals");
    setWeeklyDownloadLoader(false);
  }
};

const getRewardRequests = async (page = 1, limit = 10) => {
  try {
    setTableLoader(true);

    const res = await getAllRewardWithdrawRequestsApi(page, limit);

    if (res.status === 200 && res.data?.status === 1) {
      const list = res.data?.data?.list || [];

      setTableData(Array.isArray(list) ? list : []);
      setRewardTotalCount(res.data.data.totalCount || 0);
      setRewardPageCount(res.data.data.totalPages || 0);
    } else {
      setTableData([]);
      setRewardTotalCount(0);
    }
  } catch (error) {
    toast.error("Failed to load reward withdrawals");
  } finally {
    setTableLoader(false);
  }
};

const RewardTableData = tableData?.map((item, index) => ({
  sNo: index + 1,
   name: item?.partnerUser?.partnerUserDetails?.[0]?.name
    ? capitalizeWords(item.partnerUser.partnerUserDetails[0].name)
    : "-",
  phone: item?.partnerUser?.phone || "-",
  role: item.role ? capitalizeWords(item.role) : "-",
  date: dateFormat(item.createdAt),
  amount: item?.amount ?? 0,
  payAmount: item?.payAmount ?? 0,
  withdrawalCharge: item?.withdrawalCharge ?? 0,
  transactionId: item?.transactionId || "-",
  paymentMode: item?.mode ? capitalizeWords(item.mode) : "-",
  attachment: item?.attachment ? (
    <img
      src={`${S3_URL}/${item.attachment}`}
      alt="attachment"
      style={{
        width: "60px",
        height: "60px", 
        objectFit: "cover",
        borderRadius: "6px",
        cursor: "pointer",
        border: "1px solid #ddd",
      }}
      onClick={() =>
        window.open(`${S3_URL}/${item.attachment}`, "_blank")
      }
    />
  ) : "-",
  status: capitalizeWords(item.status),

  
  action:
    item?.status === "pending" ? (
      <div className="dropdown">
        <button
          className="border-0 bg-white"
          type="button"
          data-bs-toggle="dropdown"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </button>

        <ul className="dropdown-menu">
          <li
            className="dropdown-item"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRewardItem(item);
              setTimeout(() => {
                document.getElementById("openWeeklyPaidModal").click();
              }, 0);
            }}
          >
            Mark As Paid
          </li>
        </ul>
      </div>
    ) : null
}));

  return (

    <>
      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            {/* <BreadCrumb /> */}
            <div className="main-content">
              {/* HEADER */}

              <ul className="nav nav-tabs mb-0">
                {/* {location.pathname?.includes("/customers") && (
                        <button
                          className={`nav-link ${(activeTab === "profileDetails") ? 'active' : ''}`}
                          onClick={() => handleChangeTab("profileDetails")}
                        >
                          Profile details
                        </button>
                      )} */}

                {tabData.map((el, index) => (
                  <li key={index} className="nav-item ms-3">
                    <button
                      className={`nav-link ${(activeTab === el.tab) ? 'active' : ''}`}
                      onClick={() => handleChangeTab(el.tab)}
                    >
                      {el.name}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="row">
                <>
                  <div className="card">
                    <div className="d-flex justify-content-between flex-wrap align-items-center mt-3 mt-lg-0">
                      {activeTab === "instant" && (
                        <button onClick={handleDownload} className="btn btn-primary" disabled={downloadLoader}>
                          {downloadLoader ? "Downloading..." : "Download Withdraw Requests"}
                        </button>
                      )}
                      {activeTab === "instant" && (
                        <LimitPagination getData={getAllRequest} />
                      )}

                      <div style={{ display: "-webkit-inline-box" }}>
                        <div className="position-relative my-3 d-flex gap-2">

                          {/* <div className="d-flex align-items-center gap-2">
                            <label htmlFor="city" className="form-label">Country</label>
                            <ReactSelect className='reactSelectMinWidth' isDisabled={adminDetail.role !== "superAdmin"} options={countryOptions} value={searchFormik?.values?.countryId} onChange={handleCountryChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Countries Available'} />
                            {searchFormik?.touched?.countryId && searchFormik?.errors?.countryId ? (<div className='req-error'>{searchFormik?.errors?.countryId}</div>) : null}
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <label htmlFor="city" className="form-label">City</label>
                            <ReactSelect className='reactSelectMinWidth' options={cityOptions} isDisabled={!searchFormik?.values?.countryId} value={searchFormik?.values?.cityId} onChange={handleCityChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Cities Available'} />
                            {searchFormik?.touched?.cityId && searchFormik?.errors?.cityId ? (<div className='req-error'>{searchFormik?.errors?.cityId}</div>) : null}
                          </div> */}

                          {activeTab === "instant" && (
                            <div style={{ display: "-webkit-inline-box" }}>
                              <div className="position-relative my-3 d-flex gap-2">

                                <div className="d-flex align-items-center gap-2">
                                  <label className="form-label">Country</label>
                                  <ReactSelect
                                    className="reactSelectMinWidth"
                                    isDisabled={adminDetail.role !== "superAdmin"}
                                    options={countryOptions}
                                    value={searchFormik.values.countryId}
                                    onChange={handleCountryChange}
                                  />
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                  <label className="form-label">City</label>
                                  <ReactSelect
                                    className="reactSelectMinWidth"
                                    options={cityOptions}
                                    isDisabled={!searchFormik.values.countryId}
                                    value={searchFormik.values.cityId}
                                    onChange={handleCityChange}
                                  />
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => searchFormik.resetForm()}
                                    disabled={!searchFormik.values.countryId}
                                  >
                                    Reset filter
                                  </button>
                                </div>

                              </div>
                            </div>
                          )}


                          {/* <div className='d-flex align-items-center gap-2'>
                            <button
                              className="btn btn-primary"
                              onClick={() => { searchFormik.resetForm(); }}
                              disabled={!searchFormik?.values?.countryId}
                            >
                              Reset filter
                            </button>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    {activeTab === "instant" && (
                      <CommonTable headers={headerData} data={RequestTableData} loading={tableLoader} />
                    )}

                    {activeTab === "weekly" && !isWeeklyDetail && (
                      <CommonTable headers={weeklyHeader} data={WeeklyTableData} loading={tableLoader} />
                    )}

                    {activeTab === "weekly" && isWeeklyDetail && (
                      <>
                        <div className="d-flex justify-content-between align-items-center mb-2">

                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => {
                              setIsWeeklyDetail(false);
                              setTableData([]);
                              getWeeklyDates();
                            }}
                          >
                            ← Back to Weekly Dates
                          </button>

                          <button
                            className="btn btn-sm btn-success"
                            onClick={handleWeeklyDownload}
                            disabled={weeklyDownloadLoader}
                          >
                            {weeklyDownloadLoader ? "Downloading..." : "Download Weekly XLSX"}
                          </button>

                        </div>

                        <CommonTable
                          headers={weeklyDetailHeaders}
                          data={WeeklyDetailTableData}
                          loading={tableLoader}
                        />
                      </>
                    )}

                    {activeTab === "reward" && (
                      <CommonTable
                        headers={headerData}
                        data={RewardTableData}
                        loading={tableLoader}
                      />
                    )}


                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        {activeTab === "instant" && totalCount > limit && (
          <div className="d-flex justify-content-center">
            <ReactPaginate
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={page}
              forcePage={selectedPage - 1}
              containerClassName="pagination"
              activeClassName="active"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
            />
          </div>
        )}

        {activeTab === "weekly" && isWeeklyDetail && weeklyTotalCount > limit && (
          <div className="d-flex justify-content-center">
            <ReactPaginate
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={handleWeeklyPageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={weeklyPageCount}
              forcePage={weeklyPage - 1}
              containerClassName="pagination"
              activeClassName="active"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
            />
          </div>
        )}

        {activeTab === "reward" && rewardTotalCount > limit && (
          <div className="d-flex justify-content-center">
            <ReactPaginate
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={(e) => {
                const page = e.selected + 1;
                setRewardPage(page);
                getRewardRequests(page, limit);
              }}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={rewardPageCount}
              forcePage={rewardPage - 1}
              containerClassName="pagination"
              activeClassName="active"
            />
          </div>
        )}


      </div>

      <button
        className="d-none"
        id="confirmModalBtn"
        data-bs-toggle="modal"
        data-bs-target="#confirmationModal">
        openmodal
      </button>
      <ConfirmationModal
        handleConfirm={handleChangeStatus}
        confirmStatus={confirmStatus}
        message={"Are You Sure?"}
      />
      <button
        className="d-none"
        id="openWeeklyPaidModal"
        data-bs-toggle="modal"
        data-bs-target="#weeklyPaidModal"
      />
      <WeeklyMarkPaidModal
        key={
          activeTab === "instant"
            ? selectedInstantItem?.id
            : activeTab === "weekly"
              ? selectedWeeklyItem?.id
              : selectedRewardItem?.id
        }
        selectedWithdrawal={
          activeTab === "instant"
            ? selectedInstantItem
            : activeTab === "weekly"
              ? selectedWeeklyItem
              : selectedRewardItem
        }
        type={activeTab}
        onSuccess={onSuccessRes}
      />


    </>

  )
}




export default WithdrawalRequest